// Library to get list of ISO 3166 country codes
import countriesData from './data_json.json'

const countries = {
  // get list to use in options
  getOptions () {
    return countriesData.map(country => ({
      value: country.Code,
      text: country.Name
    }))
  },
  // get title by code
  getNameByCode (code) {
    return countriesData.find(country => country.Code === code).Name
  }

}

export default countries
